export enum TableType {
  Default = 'default',
  Accented = 'accented',
  WithImages = 'withImages',
  EvenColumns = 'evenColumns',
  InsuranceAmount = 'insuranceAmount'
}
